import PasswordReset from 'app/models/password_reset';
import Base from 'app/views/base';

import { setLocation } from 'utils/wrappers';
import { showResponseError } from 'utils/messages';

import tmpl from 'templates/password_reset';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #password_reset_form': 'submit',
  },

  initialize(options) {
    this.model = new PasswordReset({ id: options.token });
  },

  afterRender() {
    this.$('#password_reset_email').focus();
  },

  submit(e) {
    e.preventDefault();

    this.model.save({
      password: this.$('input#password_reset_password').val(),
      password_confirmation: this.$('input#password_reset_password_confirmation').val(),
    }, {
      success() {
        setLocation('/account/shipments');
      },
      error(model, response) {
        showResponseError(response);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/password_reset_page.js